import { PDFDocument } from 'pdf-lib';
import { useToast } from '@/components/ui/Toast';

export const PDF_CONFIG = {
  MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB
  MAX_FILE_COUNT: 20,
  ACCEPTED_TYPES: {
    'application/pdf': ['.pdf'],
  },
};

export const BRAND_COLORS = {
  primary: '#E8445A',
  primarySurface: '#FFF0F2',
  primaryBorder: '#FFD6DB',
  primaryShadow: 'rgba(232, 68, 90, 0.28)',

  secondary: '#4A4A6A',
  secondarySurface: '#F8F8FC',
  secondaryBorder: '#EEEEF5',

  text: {
    dark: '#1A1A2E',
    muted: '#8888A8',
    light: '#4A4A6A',
  },

  success: '#16A34A',
  successSurface: '#F0FDF4',
};

export const UI_STYLES = {
  borderRadius: {
    base: '12px',
    large: '16px',
    xl: '20px',
    full: '9999px',
  },
  transitions: {
    base: 'transition-all duration-200',
    slow: 'transition-all duration-300',
  },
};

export async function getPdfMeta(file: File) {
  const id = crypto.randomUUID();
  const name = file.name;
  const size = file.size;

  try {
    const arrayBuffer = await file.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);

    return {
      id,
      name,
      size,
      file,
      pageCount: pdfDoc.getPageCount(),
    };
  } catch {
    return {
      id,
      name,
      size,
      file,
      pageCount: 0,
    };
  }
}

export function useEncryptedPdfToast() {
  const { showToast } = useToast();

  function showEncryptedPdfToast(action?: string) {
    const message = action
      ? `This PDF is password-protected. Please unlock it before ${action}.`
      : 'This PDF is password-protected. Please unlock it first.';

    showToast(message, 'error', {
      text: 'Unlock PDF',
      href: '/unlock-pdf',
    });
  }

  return { showEncryptedPdfToast };
}
